<body class="h-screen flex justify-center items-center">
<div class="text-center">
  <img src="../../../../assets/images/branding/YSC-logo.png" alt="Logo" class="mb-4 mx-auto">
  <p class="text-h6 m-6">Set password for your account</p>
  <form [formGroup]="setupPasswordForm" (ngSubmit)="onSetPasswordClicked()" class="space-y-4 text-start">
    <div class="flex flex-col gap-2">
      <app-text-input [type]="'password'" formControlName="password" [label]="'Password'"
                      placeholder="********" class="w-full" [fullWidth]="true"></app-text-input>
      <app-text-input [type]="'password'" formControlName="confirmPassword" [label]="'Confirm Password'"
                      placeholder="*********" class="w-full" [fullWidth]="true"></app-text-input>
      @if (setupPasswordForm.hasError('passwordsMismatch')) {
        <div class="text-error-500 text-caption">Please ensure both passwords are the same.</div>
      }
    </div>
    <div class="py-4">
      <app-button [fullWidth]="true" type="submit" [loading]="setupPasswordState.loading()">Set Password</app-button>
    </div>
  </form>
</div>
</body>
